import {MenuFormat} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {EditorPreviewItem} from "./PreviewItem";
import {EditorPage} from "../editorUtils";
import {ReactComponent as TrashIcon} from "components/Icons/trash.svg";
import {useAppDispatch, useAppSelector} from "../../../lib/redux/hooks";
import {menuEditorActions, menuEditorSelectors} from "../editorSlice";
import {Footer} from "./Footer";
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";
import {DndId} from "./dragndrop";
import { createDocumentHandler } from "../documentHandlerUtils";

export interface EditorPreviewPageProps {
    format: MenuFormat
    page: EditorPage
    displayFooter: boolean
    degu: boolean
    dndItems: DndId[]
    isPreview?: boolean
}

export function EditorPreviewPage(props: EditorPreviewPageProps): ReactElement | null {
    const dispatch = useAppDispatch();
    const openDeletePageModal = () => dispatch(menuEditorActions.openDeletePopover(props.page.key));

    const document = useAppSelector(menuEditorSelectors.document);
    if (!props.dndItems || !document) {
        return <></>
    }
    const docHandler = createDocumentHandler(document);
    const pageStyling = docHandler.getPageStyling('preview');

    const page = (
        <div className={`bg-white flex flex-col relative
                ${pageStyling.className}
            `}
            style={pageStyling.style}
        >
            <button className="absolute top-2 right-2"
                    style={{zIndex: 49}}
                    onClick={openDeletePageModal}
            >
                <TrashIcon className="text-secondary w-6 h-6"/>
            </button>

            <div>
                {props.page.page.map((item, index) => (
                    <EditorPreviewItem
                        key={index}
                        item={{
                            itemKey: {
                                page: props.page.key,
                                item: index
                            },
                            menuItem: item
                        }}
                        format={props.format}
                        degu={props.degu}
                        isPreview={props.isPreview}
                        isSortable={docHandler.isItemSortable(item)}
                    />
                ))}
            </div>

            {props.displayFooter && <Footer degu={props.degu}/>}
        </div>
    );

    return (
        <SortableContext
            strategy={verticalListSortingStrategy}
            items={props.dndItems}
        >
            {page}
        </SortableContext>
    );
}
